import { useEffect, useState } from "react";
import { Button, Form } from "reactstrap";
import { StatusDataRealokasi } from "../../../Constant/StatusData";
import { SelectionField } from "../../../CommonElements";
import FormModal from "../../../Layout/Components/FormModal";
import { updateStatusRealokasi } from "../services";

const EditStatusRealokasiModal = ({
  isOpen,
  toggle,
  selectedRealokasi,
  refreshRealokasi,
  axiosInstance,
}) => {
  const [waitingForSubmit, setWaitingForSubmit] = useState(false);
  const [formData, setFormData] = useState({
    id_status_realokasi: "",
  });

  useEffect(() => {
    if (selectedRealokasi) {
      setFormData({
        id_status_realokasi: selectedRealokasi.id_status_realokasi,
      });
    }
  }, [selectedRealokasi]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setWaitingForSubmit(true);

      updateStatusRealokasi(
        axiosInstance,
        selectedRealokasi.id,
        formData,
        selectedRealokasi.is_target === "t"
      ).then(() => {
        toggle();
        refreshRealokasi();
      });
    } finally {
      let timer = setTimeout(() => setWaitingForSubmit(false), 1000);
      return () => clearTimeout(timer);
    }
  };

  return (
    <FormModal
      title={"Edit Status Realokasi"}
      isOpen={isOpen}
      toggle={toggle}
      footerButtons={
        <>
          <Button
            color="primary"
            onClick={handleSubmit}
            disabled={waitingForSubmit}
          >
            Submit
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </>
      }
    >
      <Form>
        <SelectionField
          state={StatusDataRealokasi}
          label={"Status Realokasi"}
          name={"id_status_realokasi"}
          onChange={handleChange}
          value={formData.id_status_realokasi}
          options={StatusDataRealokasi}
          optionsName={"nama_status"}
          optionsValue={"id"}
        />
      </Form>
    </FormModal>
  );
};

export default EditStatusRealokasiModal;
